module.exports = __webpack_public_path__ + "assets/rapidowallet.c070f35a2e94188ac65d9ec75b0a7f94.svg";